import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class EmployerFilterOption extends BaseModel {
  static override constructorName = 'EmployerFilterOption'

  id: string | number = ''
  name: string = ''
  value: boolean = false
  count: number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(EmployerFilterOption)
